import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, updateCSRFToken } from "helpers/api_helper";
import { decrypt, getValuesSocketData } from "helpers/secretManager";
import * as URL from "helpers/url_helper";
import { toast } from "react-toastify";

export const jackpotHistoryListApi = createAsyncThunk(
  "jackpotHistoryListApi",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.JACKPOT_HISTORY_LIST, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);

export const jackpotHistoryDetailsApi = createAsyncThunk(
  "jackpotHistoryDetailsApi",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.JACKPOT_HISTORY_DETAILS + "/" + data?._id, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);
